<template>
  <div class="check-in-form">
    <a-form :form="form">
      <a-form-item label :wrapper-col="{ span: 24 }">
        <a-input
          placeholder="请填写旅客姓名"
          v-decorator="[
              'passengerName',
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          size="large"
        />
      </a-form-item>
      <!-- <a-form-item label :wrapper-col="{ span: 24 }">
        <a-select
          placeholder="凭证类型"
          v-decorator="[
                'idType',
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'change'
                }
              ]"
          size="large"
        >
          <a-select-option value="NI">身份证</a-select-option>
          <a-select-option value="PP">有效护照</a-select-option>
          <a-select-option value="TN">客票号码</a-select-option>
        </a-select>
      </a-form-item> -->
      <a-form-item label :wrapper-col="{ span: 24 }">
        <a-input
          placeholder="请输入您的证件号码"
          v-decorator="[
              'idNo',
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          size="large"
        />
      </a-form-item>
      <a-form-item label :wrapper-col="{ span: 24 }">
        <a-input
          placeholder="请输入您的13位客票号码"
          v-decorator="[
              'ticketNo',
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          size="large"
        />
      </a-form-item>
      <a-form-item label :wrapper-col="{ span: 24 }">
        <a-date-picker
            value-format="YYYY-MM-DD"
            placeholder="请选择航班日期"
            size="large"
            :disabled-date="disabledDate"
            :locale="locale"
            v-decorator="[
              'flightDate',
              {
                initialValue: moment().format('YYYY-MM-DD'),
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          >
        </a-date-picker>
      </a-form-item>
      <a-form-item label :wrapper-col="{ span: 24 }" v-if="hasPhoneField">
        <a-input
          placeholder="请输入您的手机号码"
          v-decorator="[
              'phone',
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
          size="large"
        />
      </a-form-item>
      <a-form-item label :wrapper-col="{ span: 24 }">
        <slider-verify ref="verify" v-model="verify" @change="onChange" size="large"></slider-verify>
      </a-form-item>
      <div class="form-submit">
        <a-button type="primary" class="checkin-btn" size="large" @click="formSubmit" :loading="isSubmitLoading">{{ buttonText[type] }}</a-button>
      </div>
    </a-form>
    <p class="alink" v-if="checkinReferArticles.list">
      <router-link class="links" v-for="(item, index) in checkinReferArticles.list" :to="item.url" :key="index" target="_blank">{{ item.name }}</router-link>
    </p>
  </div>
</template>
<script>
import { validate } from '@/assets/js/validate'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN'
import moment from 'moment'

export default {
  props: {
    idInfo: {
      type: Object,
      default: function () {
        return {}
      }
    },
    passengerData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    checkinReferArticles: {
      type: Object,
      default: function () {
        return {}
      }
    },
    hasPhoneField: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'verify'
    },
    isSubmitLoading: {
      type: Boolean,
      default: false
    }

  },
  data () {
    return {
      form: this.$form.createForm(this),
      verify: false,
      buttonText: {
        'verify': '开始办理',
        'add': '确定添加'
      },
      locale
    }
  },
  methods: {
    moment,
    handleFieldValidate (rule, value, callback) {
      const formValues = this.form.getFieldsValue()
      validate('checkin-form', formValues, rule.fullField).then(({ valid, errors }) => {
        if (valid) {
          callback()
        } else {
          callback(errors[0].message)
        }
      })
    },
    formSubmit () {
      const { type } = this
      this.form.validateFields(async (err, values) => {
        if (!err) {
          if (!this.verify) {
            this.$message.error('请完成滑块验证')
            return
          }
          const { passengerName, idNo: certNo, ticketNo, flightDate, phone } = values
          const data = {
            passengerName,
            certNo,
            ticketNo,
            flightDate
          }
          if (type === 'verify') {
            data.phone = phone
          }
          this.$emit('callback', data, type)
        }
      })
    },
    onChange (value) {
      if (value) {
        this.verify = value
      }
    },
    disabledDate (current) {
      return current < moment().subtract(2, 'years').subtract(1, 'day') || current > moment().add(2, 'years')
    }
  }
}
</script>
<style lang="less" scoped>
.check-in-form {
  ::v-deep .ant-form-explain {
    margin-top: 0;
  }
  .form-submit .checkin-btn.ant-btn {
    width: 100%;
  }
  .alink {
    padding-top: 10px;
    display: flex;
    justify-content: space-around;
    .links {
      font-size: 14px;
      line-height: 1.5;
      color: @primary-color;
      text-decoration: underline;
    }
  }
  .ant-calendar-picker {
    width: 100%;
  }
}
@media only screen and (max-width: 768px) {
  .check-in-form {
    width: 96%;
    margin: 0 auto;
  }
}
</style>
